define.alias("shared/components/shared/post/secondary/activity/divider", "settings/components/shared/post/secondary/activity/divider");